module.exports = __webpack_public_path__ + "img/client_shriners.27b711b8.webp";